import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../screens/auth/login';
import Home from '../screens/dashboard/home/page';
import NewQuote from '../screens/dashboard/newQuote/page';
import UpdateQuote from '../screens/dashboard/updateQuote/page';
import Customers from '../screens/dashboard/customers/page';
import Product from '../screens/dashboard/products';
import ProductSaw from '../screens/dashboard/productSaw';
import Quotes from '../screens/dashboard/qoutes/page';
import Saw from '../screens/dashboard/saw/page';
import Layout from '../components/layout/layout';
import Setting from '../screens/dashboard/settingPage';
import Profile from '../screens/dashboard/profilePage';
import Unauthorized from '../screens/dashboard/unauthorized';
import ProtectedRoute from './protectedRoute';
import ForgotPassword from '../screens/auth/forgotPassword';
import NotFound from '../screens/dashboard/notFound';
import ModularConveyors from '../screens/dashboard/modularConveyor/page';
import MasterPriceList from '../screens/dashboard/masterPriceList/page';
import Update from '../screens/dashboard/update/page';
import Reports from '../screens/dashboard/reports/page';
import BackfillGrandTotals from '../screens/dashboard/admin/backfillGrandTotals';
import Help from '../screens/dashboard/help/page';

const RoutesCollection = () => {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        {/* Protected routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/404" element={<NotFound />} />
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/new-quote" element={<NewQuote />} />
            <Route path="/update-quote/:id" element={<UpdateQuote />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/product" element={<Product />} />
            <Route path="/productsaw" element={<ProductSaw />} />
            <Route path="/modularConveyor" element={<ModularConveyors />} />
            <Route path="/master-price-list" element={<MasterPriceList />} />
            <Route path="/quotes" element={<Quotes />} />
            <Route path="/saw" element={<Saw />} />
            <Route path="/settings" element={<Setting />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/update/:id" element={<Update />} />
            <Route path="/reports/sales" element={<Reports />} />
            <Route path="/help" element={<Help />} />
            <Route path="/admin/backfill-grand-totals" element={<BackfillGrandTotals />} />
          </Route>
        </Route>

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </Router>
  );
};

export default RoutesCollection;